// extracted by mini-css-extract-plugin
export default {"content":"CollapsibleCard_content__7IdBm"};